module.exports = __webpack_public_path__ + "static/media/400121_02.7d6e1698.png";